
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://kjixiazwcqgpjcktkbfu.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtqaXhpYXp3Y3FncGpja3RrYmZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM3NzQxMTYsImV4cCI6MjA1OTM1MDExNn0.eeouo2sMQCJv6hCS6E7oysazYyn3YPCZqMFBWa5U7DI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof window !== 'undefined' ? localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  }
});

// Define event types for easier access
export type Event = Database['public']['Tables']['events']['Row'];
export type EventInsert = Database['public']['Tables']['events']['Insert'];
export type EventUpdate = Database['public']['Tables']['events']['Update'];

// Helper function for events - using admin RPC function to avoid RLS recursion
export const getEvents = async (startDate: Date, endDate: Date) => {
  try {
    // Use admin RPC function to avoid RLS recursion
    const { data, error } = await supabase.rpc('admin_get_events', {
      p_start_date: startDate.toISOString(),
      p_end_date: endDate.toISOString()
    });
    
    return { data: data as Event[] | null, error };
  } catch (error) {
    console.error('Error fetching events:', error);
    return { data: null, error };
  }
};

// These functions will be implemented in supabase-helpers.ts to work around
// the TypeScript issues until the database schema is fully updated
export const createEvent = async (eventData: EventInsert) => {
  throw new Error('Please use temporaryCreateEvent from supabase-helpers.ts instead');
};

export const updateEvent = async (id: string, eventData: EventUpdate) => {
  throw new Error('Please use temporaryUpdateEvent from supabase-helpers.ts instead');
};

export const deleteEvent = async (id: string) => {
  throw new Error('Please use temporaryDeleteEvent from supabase-helpers.ts instead');
};
